// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Logo_wrapper__3_JEF","logo":"Logo_logo__3JTLx"};